import React from 'react';

export default {
	'Error.Unknown': 'Unbekannter Fehler',
	'Error.Unknown.Message': 'Es ist ein Fehler aufgetreten.',
	'Error.NotFound': 'Nicht gefunden',
	'Error.NotFound.Message': 'Die angeforderte Seite konnte nicht gefunden werden.',
	'Error.Forbidden': 'Verboten',
	'Error.Forbidden.Message': 'Sie haben keine Berechtigung, auf diese Seite zuzugreifen.',
	'Error.Invalid': 'Ungültige Eingabe',
	'Error.Invalid.Message': 'Ungültige Felder: {{fields}}.',
	'Error.FileSize.Message': 'Die Datei, die Sie hochladen wollten, war zu groß.',
	'PTMD Portal': 'PTMD Portal',
	'Login': 'Login',
	'Logout': 'Abmelden',
	'FileDrop.Release': 'Zum Auswählen der Datei die Loslassen-Taste drücken',
	'FileDrop.Drag': () => <h5>Ziehen Sie eine Datei per Drag & Drop hierher<br/> oder </h5>,
	'FileDrop.Select': 'Wählen Sie eine Datei aus',
	'GiB': '{{size}} GiB',
	'MiB': '{{size}} MiB',
	'KiB': '{{size}} KiB',
	'bytes': '{{size}} Bytes',
	'FileSize.Max': 'Die maximale Uploadgröße beträgt {{size}}',
	'Modal.Open': 'Offen',
	'Modal.Close': 'Schließen',
	'Language': 'Sprache'
};
